<template>
  <div id="invoice-page" v-if="isMounted">
    <div
      class="flex flex-wrap items-center justify-between"
      v-if="getMainInfo.prStatus == 'PO Generated'"
    >
      <div class="flex items-center">
        <vs-button
          class="mb-base mr-3"
          icon-pack="feather"
          icon="icon icon-file"
          @click="printInvoice"
          >Print</vs-button
        >
      </div>
    </div>

    <vx-card id="invoice-container">
      <!-- INVOICE METADATA -->
      <div class="vx-row leading-loose p-base">
        <div class="vx-col w-1/2 mt-base">
          <img height="200px" :src="getLogo" alt="vuexy-logo" />
          <vs-row>
            <vs-col>{{ userDetails.branch.branchName }}</vs-col>
          </vs-row>
          <vs-row>
            <vs-col>{{ userDetails.billingAddress.billAddress1 }}</vs-col>
          </vs-row>
          <vs-row>
            <vs-col>{{ userDetails.billingAddress.billAddress2 }}</vs-col>
          </vs-row>
          <vs-row>
            <vs-col
              >Tel: {{ userDetails.billingAddress.contactNumber }} Fax:
              {{ userDetails.billingAddress.faxNumber }}</vs-col
            >
          </vs-row>
        </div>
        <div class="vx-col w-1/2 text-right">
          <h1>{{ title }}</h1>
          <div class="invoice__invoice-detail mt-6">
            <h6>{{ showLabel }} NO.</h6>
            <p>{{ getMainInfo.prNumber }}</p>

            <h6 class="mt-4">{{ showLabel }} DATE</h6>
            <p>{{ getMainInfo.prDate }}</p>
          </div>
        </div>
      </div>

      <div>
        <vs-table :data="userDetails.items">
          <vs-tr>
            <vs-th>Requestor</vs-th>
            <vs-td>{{ userDetails.user.name }}</vs-td>

            <vs-th>Branch</vs-th>
            <vs-td>{{ userDetails.branch.branchName }}</vs-td>
          </vs-tr>
          <vs-tr>
            <vs-th>Department</vs-th>
            <vs-td>{{ userDetails.department.departmentName }}</vs-td>

            <vs-th>Due Date</vs-th>
            <vs-td>{{ getMainInfo.prDeliveryDate }}</vs-td>
          </vs-tr>

          <vs-tr>
            <vs-th>Client</vs-th>
            <vs-td>{{ getMainInfo.prClient }}</vs-td>

            <vs-th>Reference</vs-th>
            <vs-td>{{ getMainInfo.prRef }}</vs-td>
          </vs-tr>

          <vs-tr>
            <vs-th>Description</vs-th>
            <vs-td>{{ getMainInfo.prDescription }}</vs-td>
            <vs-th>Vendor</vs-th>
            <vs-td>{{ userDetails.vendor.companyName }}</vs-td>
          </vs-tr>
        </vs-table>
      </div>

      <!-- INVOICE CONTENT -->
      <div class="p-base">
        <vs-divider>ITEMS</vs-divider>
        <!-- INVOICE TASKS TABLE -->
        <vs-table hoverFlat :data="userDetails.items">
          <!-- HEADER -->
          <template slot="thead">
            <vs-th class="pointer-events-none">Item Code</vs-th>
            <vs-th class="pointer-events-none">Item Description</vs-th>
            <vs-th class="pointer-events-none">Qty.</vs-th>
            <vs-th class="pointer-events-none">Pre-Tax</vs-th>
            <vs-th class="pointer-events-none">Tax (%)</vs-th>
            <vs-th class="pointer-events-none">Price</vs-th>
            <vs-th class="pointer-events-none">Total Amount</vs-th>
          </template>

          <!-- DATA -->
          <template slot-scope="{ data }">
            <vs-tr v-for="(tr, index) in data" :key="index">
              <vs-td :data="data[index].itemName">{{
                data[index].itemName
              }}</vs-td>
              <vs-td :data="data[index].description">{{
                data[index].description
              }}</vs-td>
              <vs-td :data="data[index].qty">{{ data[index].qty }}</vs-td>
              <vs-td :data="data[index].preTax">{{ data[index].preTax }}</vs-td>
              <vs-td :data="data[index].tax">{{ data[index].tax }}</vs-td>
              <vs-td :data="data[index].price"
                >{{ data[index].price }}
                {{ userDetails.currency.currencyName }}</vs-td
              >
              <vs-td :data="data[index].total"
                >{{ data[index].total }}
                {{ userDetails.currency.currencyName }}</vs-td
              >
            </vs-tr>
          </template>
        </vs-table>

        <!-- INVOICE SUMMARY TABLE -->
        <vs-table
          hoverFlat
          class="w-1/2 ml-auto mt-4"
          :data="userDetails.items"
        >
          <vs-tr>
            <vs-th class="pointer-events-none">SUBTOTAL</vs-th>
            <vs-td
              >{{ getMainInfo.subTotal }}
              {{ userDetails.currency.currencyName }}</vs-td
            >
          </vs-tr>
          <vs-tr>
            <vs-th class="pointer-events-none"
              >TAX ({{ getMainInfo.tax }}%)</vs-th
            >
            <vs-td
              >{{ getTax() }} {{ userDetails.currency.currencyName }}</vs-td
            >
          </vs-tr>
          <vs-tr>
            <vs-th class="pointer-events-none">TOTAL</vs-th>
            <vs-td
              >{{ getMainInfo.total }}
              {{ userDetails.currency.currencyName }}</vs-td
            >
          </vs-tr>
        </vs-table>
      </div>

      <!-- INVOICE FOOTER -->
    </vx-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "@/axios.js";

import { axiosMixin } from "../../../mixin/axiosMixin";
import { helperMixin } from "../../../mixin/helperMixin";
import { alertMixin } from "../../../mixin/alertMixin";
export default {
  mixins: [axiosMixin, helperMixin, alertMixin],
  components: {},

  props: {
    title: String,
  },

  data() {
    return {
      isMounted: false,
      mailTo: "",
      userDetails: {},
      currentSubject: this.$route.params.subject,
    };
  },

  computed: {
    ...mapGetters({
      getSystemSettings: "auth/getSystemSettings",
      getUserInfo: "auth/getUserInfo",
      getDataStructureInChunk: "profile/getDataStructureInChunk",
      getMainInfo: "profile/getMainInfo",
    }),
    showLabel() {
      return "PR";
    },
    getLogo() {
      return axios.defaults.baseURL + "/storage/" + this.getSystemSettings.logo;
    },
  },

  watch: {
    $route(to, from) {
      this.currentSubject = to.params.key;
    },
  },

  created() {
    this.isMounted = false;
  },

  mounted() {
    console.log("getMainInfo:", this.getMainInfo);
    this.getUserPRUserInfo();
    this.$emit("setAppClasses", "invoice-page");
  },

  methods: {
    printInvoice() {
      window.open(
        axios.defaults.baseURL + "/printPR/" + this.getMainInfo.prNumber
      );
    },
    getTax() {
      return (
        (parseInt(this.getMainInfo.tax) / 100) *
        parseInt(this.getMainInfo.subTotal)
      );
    },
    getUserPRUserInfo() {
      console.log("currentSubject:", this.currentSubject);

      var userInfoEndpoint = "userDetails";

      if (this.currentSubject == "contractPR") {
        userInfoEndpoint = "contractPrUserDetails";
      }

      this.aronPost(
        userInfoEndpoint,
        {
          prCurrency: this.getMainInfo.prCurrency,
          userId: this.getMainInfo.userId,
          vendorId: this.getMainInfo.prVendorId,
          prId: this.getMainInfo.id,
        },
        "",
        ""
      )
        .then((response) => {
          console.log("userInfo:", response.data);
          this.userDetails = response.data;
          this.isMounted = true;
        })
        .catch((error) => {
          this.decodeErrorFromAxios(error);
        });
    },
  }
};
</script>

<style lang="scss">
@media print {
  .invoice-page {
    * {
      visibility: hidden;
    }

    #content-area {
      margin: 0 !important;
    }

    .vs-con-table {
      .vs-con-tbody {
        overflow: hidden !important;
      }
    }

    #invoice-container,
    #invoice-container * {
      visibility: visible;
    }
    #invoice-container {
      position: absolute;
      left: 0;
      top: 0;
      box-shadow: none;
    }
  }
}

@page {
  size: auto;
}
</style>